import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import countries from "../../../json/country.json";
import axios from "../../../lib/axios";
// import SelectAccount from "react-select"; // NONAKTIF: sumber Salesforce diganti Odoo

const FormIndividuComp = () => {
  const dispatch = useDispatch();
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );
  const [loadingKota, setLoadingKota] = useState(false);
  const [loadingKecamatan, setLoadingKecamatan] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);

  const [isMitraBaru, setisMitraBaru] = useState(false);
  // === STATE SALESFORCE DINONAKTIFKAN (sumber Nama Perusahaan sekarang Odoo) ===
  // const [searchAccountSf, setsearchAccountSf] = useState(
  //   dataInputRegistration.namaPerusahaanIndividu
  // );
  // const [listAccountSf, setlistAccountSf] = useState([]);

  // Autocomplete Nama Perusahaan (sumber: Odoo via /odoo/res-partners)
  const [companyOptions, setCompanyOptions] = useState([]);
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);
  const companySearchTimer = useRef(null);

  const handleChangeFormInput = (key, e) => {
    if (key === "SET_FILE_KIP_INDIVIDU") {
      dispatch({ type: key, value: e.target.files[0] });
    } else if (key === "SET_NIK_INDIVIDU") {
      // Hanya angka yang boleh masuk (mencegah autofill browser mengisi teks)
      dispatch({ type: key, value: e.target.value.replace(/\D/g, "") });
    } else {
      dispatch({ type: key, value: e.target.value });
    }
  };

  const fetchProvinsi = async () => {
    try {
      const options = {
        url: "/locations/states",
        method: "GET",
      };
      const { data } = await axios(options);
      // console.log(data)
      setProvinces(data.provinsi);
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data)
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneProvinsi = async (idProvinsi) => {
    try {
      const options = {
        url: `/locations/states/${idProvinsi}`,
        method: "GET",
      };
      const { data } = await axios(options);
      dispatch({ type: "SET_PROVINSI_INDIVIDU", value: data.nama });
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data)
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchKota = async (idProvinsi) => {
    try {
      if (idProvinsi) {
        const options = {
          url: `/locations/cities?stateId=${idProvinsi}`,
          method: "GET",
        };
        const { data } = await axios(options);
        // console.log(data)
        setCities(data.kota_kabupaten);
        setLoadingKota(false);
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data)
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneKota = async (idKota) => {
    try {
      const options = {
        url: `/locations/cities/${idKota}`,
        method: "GET",
      };
      const { data } = await axios(options);
      dispatch({ type: "SET_KOTA_INDIVIDU", value: data.nama });
      setLoadingKota(false);
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data)
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchSubDistricts = async (idCity) => {
    try {
      if (idCity) {
        const options = {
          url: `/locations/subdistricts?cityId=${idCity}`,
          method: "GET",
        };
        const { data } = await axios(options);
        // console.log(data)
        setSubDistricts(data.kecamatan);
        setLoadingKecamatan(false);
      }
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data)
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const fetchOneSubDistricts = async (idSubdistricts) => {
    try {
      const options = {
        url: `/locations/subdistricts/${idSubdistricts}`,
        method: "GET",
      };
      const { data } = await axios(options);
      dispatch({ type: "SET_KECAMATAN_INDIVIDU", value: data.nama });
      setLoadingKecamatan(false);
    } catch (err) {
      if (err) {
        // console.log(err?.response?.data)
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const handleChangeProvinsi = (e) => {
    setLoadingKota(true);
    dispatch({ type: "SET_PROVINSI_ID_INDIVIDU", value: e.target.value });
    fetchOneProvinsi(e.target.value);
    fetchKota(e.target.value);
  };

  const handleChangeKota = (e) => {
    setLoadingKecamatan(true);
    dispatch({ type: "SET_KOTA_ID_INDIVIDU", value: e.target.value });
    fetchOneKota(e.target.value);
    fetchSubDistricts(e.target.value);
  };

  const handleChangeKecamatan = (e) => {
    dispatch({ type: "SET_KECAMATAN_ID_INDIVIDU", value: e.target.value });
    fetchOneSubDistricts(e.target.value);
  };

  useEffect(() => {
    fetchProvinsi();
    fetchKota(dataInputRegistration.provinsiIdIndividu);
    fetchSubDistricts(dataInputRegistration.kotaIdIndividu);
  }, []);

  // === FETCH ACCOUNT SALESFORCE DINONAKTIFKAN (diganti Odoo /odoo/res-partners) ===
  // const [loading, setLoading] = useState(false);
  //
  // useEffect(() => {
  //   const fetchAccountSf = async () => {
  //     setLoading(true);
  //     try {
  //       await new Promise((resolve) => setTimeout(resolve, 1000));
  //       const data = await fetch(
  //         `https://sf-services.prasmul-eli.co/api/accounts?account=${searchAccountSf}`
  //       );
  //       const response = await data.json();
  //       response.data.records.map((d) =>
  //         setlistAccountSf((listAccountSf) => [
  //           ...listAccountSf,
  //           {
  //             label: d.Name,
  //             value: d.Id,
  //           },
  //         ])
  //       );
  //
  //       if (response.data.records.length === 0) {
  //         setlistAccountSf([]);
  //         setlistAccountSf((listAccountSf) => [
  //           ...listAccountSf,
  //           {
  //             label: searchAccountSf,
  //             value: searchAccountSf,
  //           },
  //         ]);
  //         dispatch({
  //           type: "SET_NAMA_PERUSAHAAN_INDIVIDU",
  //           value: searchAccountSf,
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //     setLoading(false);
  //   };
  //
  //   if (searchAccountSf !== "") {
  //     fetchAccountSf();
  //   } else {
  //     setlistAccountSf([]);
  //   }
  // }, [searchAccountSf]);
  //
  // const handleChangeNamaPerusahaan = (newValue) => {
  //   setsearchAccountSf(newValue);
  // };
  //
  // const handleSelectChangeNamaPerusahaan = (selectedOption) => {
  //   dispatch({
  //     type: "SET_NAMA_PERUSAHAAN_INDIVIDU",
  //     value: selectedOption.label,
  //   });
  // };

  // Ambil daftar nama perusahaan dari Odoo lewat route backend /odoo/res-partners
  const fetchResPartners = async (search) => {
    try {
      setLoadingCompany(true);
      const { data } = await axios({
        url: "/odoo/res-partners",
        method: "GET",
        params: { search },
      });
      setCompanyOptions(data?.data || []);
      setShowCompanyOptions(true);
    } catch (err) {
      setCompanyOptions([]);
    } finally {
      setLoadingCompany(false);
    }
  };

  // Dipanggil saat user mengetik di input Nama Perusahaan (debounce 400ms)
  const handleKeyUpNamaPerusahaanIndividu = (e) => {
    const value = e.target.value;
    dispatch({ type: "SET_NAMA_PERUSAHAAN_INDIVIDU", value });

    if (companySearchTimer.current) clearTimeout(companySearchTimer.current);

    const keyword = value.trim();
    if (keyword.length < 3) {
      setCompanyOptions([]);
      setShowCompanyOptions(false);
      return;
    }

    companySearchTimer.current = setTimeout(() => {
      fetchResPartners(keyword);
    }, 400);
  };

  // Saat user memilih salah satu saran nama perusahaan
  const handlePickNamaPerusahaanIndividu = (name) => {
    dispatch({ type: "SET_NAMA_PERUSAHAAN_INDIVIDU", value: name });
    setShowCompanyOptions(false);
    setCompanyOptions([]);
  };

  // console.log(dataInputRegistration.namaPerusahaanIndividu)

  return (
    <>
      <p style={{ fontSize: "16px", fontWeight: "400", marginBottom: "2%" }}>
        1. Silahkan lengkapi Data Peserta berikut untuk lanjut ke proses
        pembayaran.
      </p>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            style={{ fontSize: "16px", fontWeight: "600" }}
            htmlFor="salutationIndividu"
            className="form-label"
          >
            Salutation
          </label>
          <input
            type="text"
            id="salutationIndividu"
            className="form-control"
            value={dataInputRegistration.salutationIndividu}
            disabled
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-6 col-12">
          <label
            style={{ fontSize: "16px", fontWeight: "600" }}
            htmlFor="NamaDepanIndividu"
            className="form-label"
          >
            Nama Depan
          </label>
          <input
            type="text"
            id="NamaDepanIndividu"
            className="form-control"
            value={dataInputRegistration.namaDepanPic}
            disabled
          />
        </div>
        <div className="col-lg-6 col-12">
          <label
            style={{ fontSize: "16px", fontWeight: "600" }}
            htmlFor="NamaBelakangIndividu"
            className="form-label required"
          >
            Nama Belakang
          </label>
          <input
            type="text"
            id="NamaBelakangIndividu"
            className="form-control"
            value={dataInputRegistration.namaBelakangPic}
            disabled
          />
        </div>
        <p className="mt-2" style={{ fontSize: "12px", fontWeight: "400" }}>
          Apabila nama anda terdiri dari satu kata: Nama Depan : <b>Budianto</b>
          , Nama Belakang : <b>Budianto</b>
        </p>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-6 col-12">
          <label
            style={{ fontSize: "16px", fontWeight: "600" }}
            htmlFor="EmailIndividu"
            className="form-label required"
          >
            Email
          </label>
          <input
            type="email"
            id="EmailIndividu"
            className="form-control"
            value={dataInputRegistration.emailPic}
            disabled
          />
        </div>
        <div className="row col-lg-6 col-12">
          <div className="col-lg-4 col-12">
            <label
              style={{ fontSize: "16px", fontWeight: "600" }}
              htmlFor="CountryIndividu"
              className="form-label required"
            >
              Negara
            </label>
            <select
              className="form-select"
              id="CountryIndividu"
              value={dataInputRegistration.codeHpPic}
              disabled
            >
              <option value="+62">Indonesia</option>
              {countries.countries.map((country, key) => (
                <option value={country.code}>{country.name}</option>
              ))}
            </select>
          </div>
          <div className="col-lg-8 col-12">
            <label
              style={{ fontSize: "16px", fontWeight: "600" }}
              htmlFor="Country"
              className="form-label required"
            >
              Nomor Handphone
            </label>
            <input
              type="text"
              id="Country"
              className="form-control"
              placeholder="81224567890"
              value={dataInputRegistration.hpPic}
              disabled
            />
          </div>
          <p className="mt-2" style={{ fontSize: "12px", fontWeight: "400" }}>
            Contoh : 8122456789 (Gunakan nomor yang terhubung dengan WhatsApp)
          </p>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-6 col-12">
          <label
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kartuIdentitasIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            htmlFor="KartuIdentitasPeserta"
            className="form-label required"
          >
            Kartu Identitas Peserta
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="KartuIdentitasPeserta"
            onChange={(e) => handleChangeFormInput("SET_KIP_INDIVIDU", e)}
            value={dataInputRegistration.kartuIdentitasIndividu}
            style={{
              borderColor:
                dataInputRegistration.kartuIdentitasIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            <option value="NIK">NIK</option>
            <option value="NPWP">NPWP</option>
          </select>
        </div>
        <div className="col-lg-6 col-12">
          <label
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.nikIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            htmlFor="NikIndividu"
            className="form-label required"
          >
            Nomor Identitas (NIK/NPWP)
          </label>
          <input
            type="text"
            id="NikIndividu"
            name="nikIndividu"
            autoComplete="off"
            inputMode="numeric"
            className="form-control mb-2"
            placeholder="Nomor Identitas (NIK/NPWP)"
            onChange={(e) => handleChangeFormInput("SET_NIK_INDIVIDU", e)}
            value={dataInputRegistration.nikIndividu}
            style={{
              borderColor:
                dataInputRegistration.nikIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.filekartuIdentitasIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            htmlFor="FileNpwpPerusahaan"
            className="form-label required"
          >
            Upload File Kartu Identitas (NIK/NPWP)
          </label>
          <input
            type="file"
            id="FileNpwpPerusahaan"
            className="form-control mb-2"
            onChange={(e) => handleChangeFormInput("SET_FILE_KIP_INDIVIDU", e)}
            style={{
              borderColor:
                dataInputRegistration.filekartuIdentitasIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            File format .JPG, .JPEG, .PNG, .PDF
          </p>
          {dataInputRegistration.filekartuIdentitasIndividu ? (
            <div className="mb-2" style={{ color: "#26D07C" }}>
              {dataInputRegistration.filekartuIdentitasIndividu &&
                `${dataInputRegistration.filekartuIdentitasIndividu.name} - ${dataInputRegistration.filekartuIdentitasIndividu.type}`}
            </div>
          ) : (
            ""
          )}
          <small style={{ color: "#0C86D9", fontWeight: 400 }}>
            <b>*Disclaimer</b>
            <br></br>
            <i>
              Data dan informasi yang Anda berikan bersifat rahasia <br></br>dan
              hanya akan digunakan untuk kepentingan administrasi, <br></br>{" "}
              pendaftaran, dan promosi dari prasmul-eli
            </i>
          </small>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.pekerjaanIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            htmlFor="PekerjaanIndividu"
            className="form-label required"
          >
            Pekerjaan
          </label>
          <input
            type="text"
            id="PekerjaanIndividu"
            className="form-control mb-2"
            placeholder="Pekerjaan"
            onChange={(e) => handleChangeFormInput("SET_PEKERJAAN_INDIVIDU", e)}
            value={dataInputRegistration.pekerjaanIndividu}
            style={{
              borderColor:
                dataInputRegistration.pekerjaanIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            Contoh: Karyawan
          </p>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className='col-lg-12 col-12'>
          <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaPerusahaanIndividu' className="form-label">Nama Perusahaan</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              id='NamaPerusahaanIndividu'
              className="form-control mb-2"
              placeholder='Nama Perusahaan'
              autoComplete="off"
              onChange={handleKeyUpNamaPerusahaanIndividu}
              onFocus={() => { if (companyOptions.length > 0) setShowCompanyOptions(true); }}
              onBlur={() => setTimeout(() => setShowCompanyOptions(false), 150)}
              value={dataInputRegistration.namaPerusahaanIndividu}
            />
            {showCompanyOptions && (loadingCompany || companyOptions.length > 0) && (
              <ul
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  zIndex: 1000,
                  margin: '-6px 0 0 0',
                  padding: 0,
                  listStyle: 'none',
                  background: '#fff',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  maxHeight: '220px',
                  overflowY: 'auto',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
                }}
              >
                {loadingCompany && (
                  <li style={{ padding: '8px 12px', fontSize: '14px', color: '#888' }}>Mencari...</li>
                )}
                {!loadingCompany && companyOptions.length === 0 && (
                  <li style={{ padding: '8px 12px', fontSize: '14px', color: '#888' }}>Tidak ditemukan</li>
                )}
                {!loadingCompany && companyOptions.map((opt) => (
                  <li
                    key={opt.id}
                    onMouseDown={() => handlePickNamaPerusahaanIndividu(opt.name)}
                    style={{ padding: '8px 12px', cursor: 'pointer', fontSize: '14px', borderBottom: '1px solid #f1f1f1' }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f5f7fa')}
                    onMouseLeave={(e) => (e.currentTarget.style.background = '#fff')}
                  >
                    {opt.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <p style={{ fontSize: '12px', fontWeight: '400' }}>Contoh: Maju Abadi, PT</p>
        </div>
        {/* <div className='col-lg-12 col-12' style={{ marginBottom: '2%' }}>
                    <input type='checkbox' onClick={() => setisMitraBaru(!isMitraBaru)} /> <b style={{ color: '#0C86D9' }}>Mitra Baru</b>
                </div>
                {
                    isMitraBaru === false ?
                        <div className='col-lg-12 col-12'>
                            <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaPerusahaanIndividu' className="form-label">Perusahaan Mitra kami</label>
                            <SelectAccount
                                value={listAccountSf.find(option => option.label === searchAccountSf)}
                                options={listAccountSf}
                                onInputChange={handleChangeNamaPerusahaan}
                                onChange={handleSelectChangeNamaPerusahaan}
                                isSearchable
                                isLoading={loading}
                                placeholder='Cari..'
                                disabled={isMitraBaru === true ? true : false}
                            />
                        </div>
                        :
                        <div className='col-lg-12 col-12' style={{ marginBottom: '2%' }}>
                            <label style={{ fontSize: '16px', fontWeight: '600' }} htmlFor='NamaPerusahaanIndividu' className="form-label">Nama Perusahaan</label>
                            <input type="text" id='NamaPerusahaanIndividu' className="form-control mb-2" placeholder='Nama Perusahaan' onChange={(e) => handleChangeFormInput('SET_NAMA_PERUSAHAAN_INDIVIDU', e)} value={dataInputRegistration.namaPerusahaanIndividu} />
                            <p style={{ fontSize: '12px', fontWeight: '400' }}>Contoh: Maju Abadi, PT</p>
                        </div>
                } */}
        {/* <div className="col-lg-12 col-12">
          <label
            style={{ fontSize: "16px", fontWeight: "600" }}
            htmlFor="NamaPerusahaanIndividu"
            className="form-label"
          >
            Nama Perusahaan
          </label>
          <SelectAccount
            value={listAccountSf.find(
              (option) => option.label === searchAccountSf
            )}
            options={listAccountSf}
            onInputChange={handleChangeNamaPerusahaan}
            onChange={handleSelectChangeNamaPerusahaan}
            isSearchable
            isLoading={loading}
            placeholder="Masukkan Nama Perusahaan"
          />
          <p style={{ fontSize: "12px", fontWeight: "400", marginTop: "5px" }}>
            Contoh: Maju Abadi{" "}
            <small style={{ color: "#0C86D9", fontWeight: 400 }}>
              <i>(Nama Perusahaan sesuaikan dengan NPWP)</i>
            </small>
          </p>
        </div> */}
      </div>

      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            style={{ fontSize: "16px", fontWeight: "600" }}
            htmlFor="JabatanIndividu"
            className="form-label"
          >
            Jabatan
          </label>
          <input
            type="text"
            id="JabatanIndividu"
            className="form-control mb-2"
            placeholder="Jabatan"
            onChange={(e) => handleChangeFormInput("SET_JABATAN_INDIVIDU", e)}
            value={dataInputRegistration.jabatanIndividu}
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12 mb-2">
          <label
            className="form-label required"
            style={{ fontSize: "16px", fontWeight: "600" }}
          >
            Alamat
          </label>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="ProvinsiIndividu"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.provinsiIdIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Provinsi
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="ProvinsiIndividu"
            onChange={(e) => handleChangeProvinsi(e)}
            value={dataInputRegistration.provinsiIdIndividu}
            style={{
              borderColor:
                dataInputRegistration.provinsiIdIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            {provinces.map((p, i) => (
              <option key={i} value={p.id}>
                {p.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="KotaIndividu"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kotaIdIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            {loadingKota === true ? "Loading.." : "Kota"}
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="KotaIndividu"
            onChange={(e) => handleChangeKota(e)}
            value={dataInputRegistration.kotaIdIndividu}
            style={{
              borderColor:
                dataInputRegistration.kotaIdIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            {cities.map((p, i) => (
              <option key={i} value={p.id}>
                {p.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="KecamatanIndividu"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kecamatanIdIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            {loadingKecamatan === true ? "Loading.." : "Kecamatan"}
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="KecamatanIndividu"
            onChange={(e) => handleChangeKecamatan(e)}
            value={dataInputRegistration.kecamatanIdIndividu}
            style={{
              borderColor:
                dataInputRegistration.kecamatanIdIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            <option value="">Pilih</option>
            {subDistricts.map((d, i) => (
              <option key={i} value={d.id}>
                {d.nama}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="KodeposIndividu"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.kodeposIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Kode Pos
          </label>
          <input
            type="text"
            id="KodeposIndividu"
            className="form-control mb-2"
            placeholder="Kode Pos"
            onChange={(e) => handleChangeFormInput("SET_KODEPOS_INDIVIDU", e)}
            value={dataInputRegistration.kodeposIndividu}
            style={{
              borderColor:
                dataInputRegistration.kodeposIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
        </div>
        <div className="col-lg-8 col-12">
          <label
            htmlFor="PatokanIndividu"
            className="form-label"
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.patokanIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Nama Jalan, Gedung, Nomor/Blok
          </label>
          <input
            type="text"
            id="PatokanIndividu"
            className="form-control mb-2"
            placeholder="Nama Jalan, Gedung, Nomor/Blok"
            onChange={(e) => handleChangeFormInput("SET_PATOKAN_INDIVIDU", e)}
            value={dataInputRegistration.patokanIndividu}
            style={{
              borderColor:
                dataInputRegistration.patokanIndividu.length === 0 &&
                  dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default FormIndividuComp;
